export class Constants {public static get API_URL(): string { return 'https://ekzn-pos.herokuapp.com/api/v1/'; }
}
